/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-24 20:41:41 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2018-05-16 15:17:48
 */

import {FETCH_COUNSELLORS, UPDATE_COUNSELLOR, FETCH_BAD_FIT, DELETE_BAD_FIT_ITEM, UPDATE_BAD_FIT_ITEM} from "./actionTypes"

export const reducer = (state = {}, action) => {
  switch(action.type) {

  case FETCH_COUNSELLORS: {
    return {...state, counsellors: [...action.counsellors]}
  }
  
  case UPDATE_COUNSELLOR: {
    const [counsellor] = action.counsellor
    const updatedCounsellors = state.counsellors.map((el) => el.id === counsellor.id ? counsellor : el )

    return {...state, counsellors: updatedCounsellors}
  }

  case FETCH_BAD_FIT: {
    return {...state, badFitItems: [...action.badFitItems]}
  }
  
  case DELETE_BAD_FIT_ITEM: {
    const updatedBadFitList = state.badFitItems.map(element => {
      const items = element.items.filter(el => el.id !== action.id)
      
      return {...element, items}
    });

    return {...state, badFitItems: updatedBadFitList}
  }

  case UPDATE_BAD_FIT_ITEM: {
    const item = action.item

    const updatedBadFitList = state.badFitItems.map(element => {
      const items = element.items.map((el) => el.id === item.id ? item : el )
      
      return {...element, items}
    });

    return {...state, badFitItems: updatedBadFitList}
  }

  default:
    return state
  }
}